import cssesc from 'cssesc'

const DEFAULT_OPTIONS = {
  quotes: 'single',
  wrap: false,
  isIdentifier: false,
} as const

/**
 * Escapes strings for safe use in CSS contexts (e.g., font-family, url()).
 *
 * Uses industry-standard cssesc library with additional angle bracket escaping
 * to prevent style tag breakout attacks in SSR contexts.
 *
 * @param value String to escape
 * @param options Optional cssesc configuration (quotes, wrap, isIdentifier)
 * @returns Escaped string safe for CSS
 *
 * @example
 * escapeCSSString("font'name") // "font\\'name"
 * escapeCSSString('font"name', { quotes: 'double' }) // "font\\"name"
 * escapeCSSString('123abc', { isIdentifier: true }) // "\\31 23abc"
 */
export function escapeCSSString(
  value: string,
  options?: Readonly<Partial<cssesc.Options>>,
): string {
  const mergedOptions = { ...DEFAULT_OPTIONS, ...options }
  const escaped = cssesc(value, mergedOptions)

  // Escape angle brackets to prevent style tag breakout in SSR
  return escaped.replaceAll('<', String.raw`\3C `).replaceAll('>', String.raw`\3E `)
}
